export const getCategoriesWithoutTree = (payload?: any) => ({
    type: "@saga/GET_CATEGORIES_WITHOUT_TREE",
    payload
});

